module.exports = __webpack_public_path__ + "static/img/jijinghuiTopNewlist.06bbd7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dymanticLanshu/jijinghuiTopNewlist.jpg
// module id = 4O6h
// module chunks = 0